// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from 'common/store/store'
import VueResource from 'vue-resource'
import newVue from 'common/js/newVue'
import './base/font/icon_font/iconfont.css'
import moment from 'moment'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import echarts from "echarts"; // 引入echarts
Vue.prototype.$echarts = echarts; // 配置echarts
Vue.prototype.$moment = moment

moment.locale('zh-cn')

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(VueQuillEditor)

Vue.directive('focus', function (el, option) {
  // eslint-disable-next-line one-var
  const defClass = 'el-input', defTag = 'input'
  let value = option.value || true
  if (typeof value === 'boolean') {
    value = {cls: defClass, tag: defTag, foc: value}
  } else {
    value = { cls: value.cls || defClass, tag: value.tag || defTag, foc: value.foc || false }
  }
  if (el.classList.contains(value.cls) && value.foc) {
    el.getElementsByTagName(value.tag)[0].focus()
  }
})
Vue.http.interceptors.push(function (request, next) {
  newVue.$emit('toggleLoading', true)
  let ifOnLine = window.navigator.onLine
  if (!ifOnLine) {
    newVue.$emit('toggleLoading', false)
    newVue.$message.error('网络已断开! 请查看网络问题!')
    return
  }
  // bus.$emit('toggleLoading', true)
  let TOKEN = localStorage.getItem('token')
  if (TOKEN) {
    // 如果请求时TOKEN存在,就为每次请求的headers中设置好TOKEN,后台根据headers中的TOKEN判断是否放行
    request.headers.set('Authorization', TOKEN)
    request.headers.set('Content-Type', 'application/json')
    request.headers.set('Access-Control-Allow-Origin', '*')
  }
  /* var timeout
  // 這裡改用 _timeout ，就不會觸發原本的
  if (request._timeout) {
    // 一樣綁定一個定時器，但是這裡是只要觸發了，就立即返回 response ， 並且這邊自定義了 status 和 statusText
    timeout = setTimeout(() => {
      if (request.onTimeout) request.onTimeout(request)
      request.abort()
    }, request._timeout)
  } */
  next(function (response) {
    newVue.$emit('toggleLoading', false)
    // clearTimeout(timeout)
    if (response.status === 0) { // 做token过期处理
      newVue.$message.error('登录异常! 请重新登录!')
     // this.$router.push({path: '/'})
    } else {
      if (response.body.code !== 200) {
        if (response.body.code === 401) {
          newVue.$message.error('登录异常! 请重新登录!')
          this.$router.push({path: '/'})
        } else if (response.body.code === 403) {
          newVue.$message.error('无访问权限!')
        } else if (response.body.code === 500) {
         // newVue.$message.error('系统错误, 请联系管理员!')
        } else {
         // newVue.$message.error('系统错误, 请联系管理员!')
        }
      }
    }
    // bus.$emit('toggleLoading', false)
    // this.loaddingShow = !this.loaddingShow
    /* if (response.status !== 0) {
      if (response.body.code === 403) { // token过期
        window.localStorage.removeItem('token')
        this.$router.push({path: '/login'})
        layer.open({
          className: 'customerLayer',
          content: response.body.message,
          skin: 'msg',
          time: 2 // 秒后自动关闭
        })
      } else if (response.body.code !== 200 && response.body.code !== 403) {
        layer.msg('tab')
      }
      return response
    } */
  })
})
Vue.component('remote-script', {

  render: function (createElement) {
    var self = this;
    return createElement('script', {
      attrs: {
        type: 'text/javascript',
        src: this.src
      },
      on: {
        load: function (event) {
          self.$emit('load', event);
        },
        error: function (event) {
          self.$emit('error', event);
        },
        readystatechange: function (event) {
          if (this.readyState == 'complete') {
            self.$emit('load', event);
          }
        }
      }
    });
  },

  props: {
    src: {
      type: String,
      required: true
    }
  }
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js